/*
 * @Author: Wang Bingjing
 * @Date: 2021-02-22 15:27:48
 * @LastEditTime: 2021-06-02 17:53:49
 * @LastEditors: zhengfan
 */
import React, { useState, useEffect } from 'react'
import { Nav } from '@alifd/next'
import { Link } from 'react-router-dom'
import '../style/AppWrapper.scss'
import { withRouter } from 'react-router-dom';
import { Shell, MenuButton, Message } from '@alifd/next';
import {
  removeAll,
  getUserId,
  getToken,
  isAuthenticated,
} from '../common/session';
import { loginMap } from '../constants/localizationMap';
import DialogModal from '../common/DialogModal';
import PasswordForm from '../pages/login/PasswordForm';
import loginApi from '../api/loginApi';
import SideBar from './SideBar'

const Wrapper = (props) => {
  const { children } = props;
  const {location} = window
  const token = getToken();
  const userId = getUserId();
  const [dialogInfo, setDialogInfo] = useState({
    visible: false,
    dialogContent: {},
  });

  const redirectToLogin = () => {
    if (!isAuthenticated()) {
      const { history } = props;
      history.push('/login');
    }
  };

  useEffect(() => {
    redirectToLogin();
  }, []);

  const logout = () => {
    removeAll();
    const { history } = props;
    history.push('/login');
  };

  const onCloseDialog = () => {
    setDialogInfo({
      visible: false,
      dialogContent: {},
    });
  };

  const onPasswordConfirm = (value, errors) => {
    if (errors) {
      return;
    }
    const { againNewPw, newPw, originPw } = value;
    if (againNewPw !== newPw) {
      Message.show({
        type: 'error',
        title: '提示',
        content: '两次密码输入新密码不一致！',
      });
      return;
    }
    if (newPw === originPw) {
      Message.show({
        type: 'error',
        title: '提示',
        content: '新密码不能与原密码相同！',
      });
      return;
    }
    const params = {
      password: newPw,
      token,
      user_id: userId,
      old_password: originPw,
    };
    loginApi.updatePassword(params).then((resp) => {
      if (resp.message === "commit user successfully!") {
        Message.show({
          type: 'success',
          title: '密码修改成功！',
          content: '请重新登录！',
        });
        logout();
      } else {
        Message.show({
          type: 'error',
          title: '密码修改失败！',
          content: `${resp.result}`,
        });
      }
    }).catch((err) => {
      if (err.response.status === 400){
        Message.show({
          type:'error',
          title: '原密码错误！',
        })
      } 
    });
  };

  const onCancel = () => {
    onCloseDialog();
  };

  const changePassword = () => {
    setDialogInfo({
      visible: true,
      dialogContent: {
        footer: false,
        title: '修改密码',
        onClose: onCloseDialog,
        content: (
          <PasswordForm
            onCancel={onCancel}
            onPasswordConfirm={onPasswordConfirm}
          />),
      },
    });
  };
  return (
    <div className="fullScreen-wrapper">
      <DialogModal
        visible={dialogInfo.visible}
        dialogContent={dialogInfo.dialogContent}
      />
      <Shell className="shell-layout-wrap">
        <Shell.Navigation>
          <SideBar />
        </Shell.Navigation>
        <Shell.Action style={{ paddingRight: 30 }}>
          <MenuButton
            type="primary"
            label={userId}
            style={{ backgroundColor: 'transparent' }}
          >
            <MenuButton.Item onClick={changePassword}>{loginMap.changePassword}</MenuButton.Item>
            <MenuButton.Item onClick={logout}>{loginMap.signOut}</MenuButton.Item>
          </MenuButton>
        </Shell.Action>
        <Shell.Content className={`${location.hash === '#/life-cycle'?'no-padding':''}`}>
          {children}
        </Shell.Content>
      </Shell>
    </div>
  )
}

export default withRouter(Wrapper)
